import {prevent} from "@splidejs/splide/src/js/utils";

function commonOfferLike(element) {
	element.querySelectorAll("[data-common-offer-like-button]").forEach(function (heart) {
		heart.addEventListener("click", function (event) {
			event.stopPropagation();
			let url = this.getAttribute("data-common-offer-like-url");
			let offerId = this.getAttribute("data-common-offer-like-id");

			if (!url || !offerId) {
				return;
			}

			// find all buttons with the same offerId and toggle them together
			document.querySelectorAll(`[data-common-offer-like-id="${offerId}"]`).forEach((btn) => {
				let wasActive = btn.classList.contains("active");

				if (wasActive) {
					btn.classList.remove("active");
					btn.classList.add("no-hover");

					btn.addEventListener("mouseleave", function removeNoHover() {
						btn.classList.remove("no-hover");
						btn.removeEventListener("mouseleave", removeNoHover);
					});
				} else {
					btn.classList.add("active");
				}

				btn.setAttribute("title", btn.classList.contains("active") ? "Odebrat z oblíbených" : "Přidat do oblíbených");
			});

			$.nette.ajax({
				url: url,
				method: "POST",
				data: { offerId: offerId },
				off: ['snippets'],
				success: function (payload) {
					//Ruční aktualizace snippetů pro počet oblíbených nabídek v desktopovém a mobilnín menu uživatele,
					//protože automatické zpracování je vypnuto pomocí off: ['snippets']
					const ids = [
						'snippet-userDropdown-countLikeOffersDesktop',
						'snippet-userDropdown-countLikeOffersMobile'
					];
					if (payload.snippets) {
						for (const id of ids) {
							if (payload.snippets[id]) {
								const el = document.getElementById(id);
								if (el) {
									el.innerHTML = payload.snippets[id];
								}
							}
						}
					}
				}
			});
		});
	});
}

export default function () {
	$.nette.ext('common-offer-like', {
		init: function () {
			commonOfferLike(document);

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					commonOfferLike($el.get(0));
				}
			});
		}
	});
}
